import { Car, Heart, Home, Shield } from 'lucide-react';

import type { ServiceItem } from './useServices';

type ServiceCardProps = {
  service: ServiceItem;
  onClick: (service: ServiceItem) => void;
};

const iconMap = {
  car: Car,
  heart: Heart,
  home: Home,
  shield: Shield,
};

const ServiceCard = ({ service, onClick }: ServiceCardProps) => {
  const Icon = iconMap[service.icon];

  return (
    <button
      onClick={() => onClick(service)}
      disabled={service.disabled}
      className="flex cursor-pointer flex-col gap-6 rounded-lg bg-surface-card p-10 text-left shadow-card transition-shadow hover:shadow-card-hover disabled:cursor-not-allowed disabled:opacity-50"
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-primary/10">
        <Icon className="h-7 w-7 text-accent-primary" />
      </div>
      <h3 className="font-heading text-2xl font-medium text-foreground-primary">
        {service.title}
      </h3>
      <p className="font-body text-base leading-relaxed text-foreground-secondary">
        {service.description}
      </p>
    </button>
  );
};

export default ServiceCard;
